import { Breadcumb } from '../../../../components';

export default Breadcumb;
